import { useEffect, useState } from 'react';
import IconArrowDown from '../../../assets/icons/IconArrowDown';
import IconArrowUp from '../../../assets/icons/IconArrowUp';
import IconTagPrice from '../../../assets/icons/IconTagPrice';
import {
  IconPositionInformation,
  Information,
  WatchInformation,
  MoreInformationButton,
  ShowInformation,
  InformationPayments,
  InformationLine,
  InformationRow,
  PromotionIconSection,
  PromotionDetailsSection,
  PromotionDetailsRow,
  InformationRowGreen,
  ExpensesAmount,
  CardInputPromotion,
  CardRowSectionOne,
  CardRowSectionTwo,
  CardAmountRow,
  CardSectionColumn,
} from './PromotionsStyledComponents';
import { TextBold, TextMedium } from '../../../styles/GlobalStyledComponents';
import {
  CardCheckbox,
  CardColumn,
  CardRow,
  CardRow2,
  CardSection,
  CheckboxContainer,
  InfoCardMiniSpan,
  InitialAmount,
  InitialAmountBox,
  PromotionIcon,
  CardLabel,
} from '../CardsStyledComponents';
import {
  LoanData,
  PromotionsData,
  TransactionReasonEnum,
  TransactionReasonTexts,
} from '../../../interfaces/Debt';
import { colors } from '../../../styles/Colors';
import { useDebtResult } from '../../../contexts/DebtContext';
import { pricesHelper } from '../../../utils/paymentsHelper';
import GAnalyticsService from '../../../services/GAnalytics/ganalytics.service';
import dayjs from 'dayjs';

interface PromotionsProps {
  promotion: PromotionsData;
  isSelected: boolean;
  onSelectInput: () => void;
  loan?: LoanData;
}
const Promotions: React.FC<PromotionsProps> = ({
  promotion,
  isSelected,
  onSelectInput,
  loan,
}) => {
  const { red4 } = colors;
  const [active, setActive] = useState<boolean>(false);

  const { debtResult } = useDebtResult();
  const isCo = sessionStorage.getItem('flow') === 'co';
  const [promotion24h, setPromotion24h] = useState<boolean>(false);
  const [initTime] = useState<dayjs.Dayjs>(dayjs());

  const selectPromotionMessage = (promotion: any) => {
    if (promotion.type === 'DIRECT_DEBIT_ERROR') {
      return (
        <TextMedium color={'gray6'} fontSize={14}>
          Parece que ha habido un error de domiciliación. ¡Paga ahora y te
          ahorras los gastos!
        </TextMedium>
      );
    } else if (promotion24h) {
      return (
        <TextMedium color={'gray6'} fontSize={14} lineHeight={20}>
          Abona tu pago en menos de 24h
        </TextMedium>
      );
    } else if (promotion.transaction_reason === TransactionReasonEnum.POP) {
      return (
        <TextMedium color={'gray6'} fontSize={14} lineHeight={20}>
          Cancela el préstamo y ahorra los gastos
        </TextMedium>
      );
    } else if (isCo) {
      return (
        <TextMedium color={'gray6'} fontSize={14} lineHeight={20}>
          Paga todo en un único pago
        </TextMedium>
      );
    } else {
      return (
        <TextMedium color={'gray6'} fontSize={14} lineHeight={20}>
          Adelanta ahora tu próxima cuota y ahorra los gastos
        </TextMedium>
      );
    }
  };

  useEffect(() => {
    if (!promotion24h && promotion.type === '24H') {
      setPromotion24h(true);
    }
  }, [promotion]);

  useEffect(() => {
    //Cerramos el desplegable de más información al cambiar de opción seleccionada
    if (!isSelected) {
      setActive(false);
    }
  }, [isSelected]);

  return (
    <CardInputPromotion
      id="promotion-card-input"
      borderColor={red4}
      cardPadding={'24px'}
      $marginBottom={isCo && promotion ? '5px' : '10px'}
      selected={isSelected}
      onClick={() => { 
        if (!isSelected) { 
          onSelectInput();
          GAnalyticsService.sendChangeDebtType(initTime, promotion.type);
      }}}
    >
      <CardRowSectionOne
        id="promotion-card-row-section-one"
        $paddingBottom={promotion24h ||isCo}
      >
        <CheckboxContainer
          id="promotion-checkbox-container"
        >
          <CardCheckbox
            id="promotion-card-checkbox"
            type="radio"
            checked={isSelected}
            readOnly
            isPromotion={true}
          />
        </CheckboxContainer>
        <CardColumn id="promotion-card-container-column">
          <CardRow id="promotion-card-row" onClick={onSelectInput}>
            <CardSectionColumn id="promotion-card-column" $coStyles={isCo}>
              <CardSection id="promotion-card-section">
                <TextBold id="promotion-title" fontSize={16} lineHeight={22}>
                  {!isCo &&
                    (promotion24h
                      ? 'Promoción 24 horas'
                      : TransactionReasonTexts[promotion.transaction_reason])}
                  {isCo && 'Pagar todo'}
                </TextBold>
              </CardSection>
              <CardSection id="promotion-details-section">
                {promotion.amount_excused !== 0 && (
                  <CardRow id="promotion-savings-row" onClick={onSelectInput}>
                    {selectPromotionMessage(promotion)}
                  </CardRow>
                )}
              </CardSection>
            </CardSectionColumn>

            {!isCo && (<PromotionIconSection id="promotion-icon-section">
              <PromotionIcon id="promotion-icon">
                <IconTagPrice />
              </PromotionIcon>
            </PromotionIconSection>)}
          </CardRow>
          <CardAmountRow id="promotion-amount-row">
            <CardSection id="promotion-amount-section">
              {promotion.amount_excused !== 0 && (
                <InitialAmountBox id="promotion-initial-amount-box">
                  <InitialAmount
                    id="promotion-initial-amount"
                    fontSize={14}
                    color={'red6'}
                    lineHeight={22}
                  >
                    {pricesHelper(promotion.amount + promotion.amount_excused)}€
                  </InitialAmount>
                </InitialAmountBox>
              )}
              <TextBold
                id="promotion-final-amount"
                fontSize={16}
                color={'gray0'}
                lineHeight={22}
              >
                {pricesHelper(promotion.amount)}€
              </TextBold>
            </CardSection>
            {promotion && promotion.amount_excused !== 0 && (
              <CardSection id="promotion-savings-section">
                <InfoCardMiniSpan id="promotion-savings-text">
                  <CardLabel fontSize={14} lineHeight={16}>
                    Ahorras{' '}
                    {promotion && pricesHelper(promotion.amount_excused)}€
                  </CardLabel>
                </InfoCardMiniSpan>
              </CardSection>
            )}
          </CardAmountRow>

          {promotion.type !== 'DIRECT_DEBIT_ERROR' &&
            !promotion24h &&
            !isCo && (
              <Information id="promotion-info-wrapper">
                <CardColumn id="promotion-info-column">
                  <CardRow2 id="promotion-info-row-2">
                    <MoreInformationButton
                      onClick={() => {
                        setActive(!active);
                        if (!active) {
                          GAnalyticsService.sendShowPromotionsDetail();
                        }
                      }}
                      id="promotion-more-info-btn"
                    >
                      <IconPositionInformation id="promotion-info-icon">
                        {active === false ? <IconArrowDown /> : <IconArrowUp />}
                      </IconPositionInformation>
                      <WatchInformation
                        id="promotion-info-text"
                        fontSize={14}
                        lineHeight={20}
                        color={'gray6'}
                      >
                        {active === false
                          ? 'Más información'
                          : 'Menos información'}{' '}
                      </WatchInformation>
                    </MoreInformationButton>
                  </CardRow2>
                </CardColumn>
              </Information>
            )}
        </CardColumn>
      </CardRowSectionOne>
      <CardRowSectionTwo id="promotion-card-row-section-two">
        {active && (
          <PromotionDetailsRow id="promotion-details-row">
            <CardColumn>
              <CardRow id="promotion-details-row">
                <PromotionDetailsSection id="promotion-details-section">
                  <TextMedium
                    id="promotion-details-text"
                    fontSize={14}
                    lineHeight={16}
                    color={'gray6'}
                  >
                    Detalles de la promoción
                  </TextMedium>
                  <TextMedium
                    id="promotion-details-text"
                    fontSize={14}
                    lineHeight={20}
                  >
                    {promotion.transaction_reason === TransactionReasonEnum.POP
                      ? 'Si cancelas el préstamo'
                      : 'Si adelantas el pago de tu próxima cuota'}{' '}
                    te ahorras{' '}
                    <TextBold
                      id="promotion-details-text-bold"
                      fontSize={14}
                      lineHeight={20}
                    >
                      {pricesHelper(promotion.amount_excused)}€
                    </TextBold>{' '}
                    {promotion.transaction_reason === TransactionReasonEnum.POP
                      ? 'de gastos.'
                      : 'de los gastos de devolución actuales.'}
                  </TextMedium>
                </PromotionDetailsSection>
              </CardRow>
              <CardRow id="promotion-info-divider-row">
                <InformationLine id="promotion-info-divider" />
              </CardRow>
              <CardRow id="promotion-info-shown">
                <ShowInformation id="promotion-info-details">
                  <InformationPayments id="promotion-info-payments">
                    <CardColumn id="promotion-info-payments-column">
                      <InformationRow id="promotion-info-debt-row">
                        <TextMedium
                          id="promotion-info-debt-label"
                          fontSize={14}
                          lineHeight={20}
                        >
                          {promotion.transaction_reason ===
                          TransactionReasonEnum.POP
                            ? 'Importe pendiente'
                            : 'Deuda pendiente'}
                        </TextMedium>
                        <TextBold
                          id="promotion-info-debt-value"
                          fontSize={14}
                          lineHeight={20}
                        >
                          {!isCo &&
                            (promotion.transaction_reason ===
                            TransactionReasonEnum.POP
                              ? promotion &&
                                pricesHelper(
                                  promotion.amount + promotion.amount_excused
                                )
                              : debtResult &&
                                pricesHelper(debtResult.amount) + '€')}
                          {isCo &&
                            loan &&
                            loan.certified_debt &&
                            pricesHelper(loan.certified_debt) + '€'}
                        </TextBold>
                      </InformationRow>
                      {promotion.transaction_reason !==
                        TransactionReasonEnum.POP &&
                        loan && (
                          <InformationRow id="promotion-info-next-fee-row">
                            <TextMedium
                              id="promotion-info-next-fee-label"
                              fontSize={14}
                              lineHeight={20}
                            >
                              Próxima cuota
                            </TextMedium>
                            <TextBold
                              id="promotion-info-next-fee-value"
                              fontSize={14}
                              lineHeight={20}
                            >
                              {loan && loan.next_due_fee
                                ? pricesHelper(loan.next_due_fee)
                                : '0'}{' '}
                              €
                            </TextBold>
                          </InformationRow>
                        )}
                      <InformationRow id="promotion-info-expenses-row">
                        <TextMedium
                          id="promotion-info-debt-label"
                          fontSize={14}
                          lineHeight={20}
                        >
                          Gastos
                        </TextMedium>
                        <ExpensesAmount
                          id="promotion-info-debt-value"
                          fontSize={14}
                          lineHeight={20}
                        >
                          {promotion && pricesHelper(promotion.amount_excused)}{' '}
                          €
                        </ExpensesAmount>
                      </InformationRow>
                      <InformationRow id="promotion-info-total-row">
                        <TextMedium
                          id="promotion-info-total-label"
                          fontSize={14}
                          lineHeight={20}
                        >
                          Total a abonar
                        </TextMedium>
                        <TextBold
                          id="promotion-info-total-value"
                          fontSize={14}
                          lineHeight={20}
                        >
                          {promotion && pricesHelper(promotion.amount)} €
                        </TextBold>
                      </InformationRow>
                      <InformationRow id="promotion-info-savings-row">
                        <InformationRowGreen id="promotion-info-savings-green">
                          <TextMedium
                            id="promotion-info-savings-label"
                            fontSize={14}
                            lineHeight={20}
                          >
                            Total ahorro
                          </TextMedium>
                          <TextBold
                            id="promotion-info-savings-value"
                            fontSize={14}
                            lineHeight={20}
                          >
                            {promotion &&
                              pricesHelper(promotion.amount_excused)}{' '}
                            €
                          </TextBold>
                        </InformationRowGreen>
                      </InformationRow>
                    </CardColumn>
                  </InformationPayments>
                </ShowInformation>
              </CardRow>
            </CardColumn>
          </PromotionDetailsRow>
        )}
      </CardRowSectionTwo>
    </CardInputPromotion>
  );
};

export default Promotions;
